import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";
import * as utils from "../../../utils.js";

export default class VistaDatosSTJHermana extends Component {
  render() {
    let VistaDatosSTJ =
      this.props.DatosMonja.sister && this.props.DatosMonja.sister.entrySTJ ? (
        <Container>
          <Row>
            <Col lg="4" className="border">
              <h6>Fecha Ingreso STJ</h6>
              <p>{utils.formatDate(this.props.DatosMonja.sister.entrySTJ)}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Número Compañía</h6>
              <p>{this.props.DatosMonja.sister.companyNumber}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Nombre Compañía</h6>
              <p>{this.props.DatosMonja.sister.companyName}</p>
            </Col>
          </Row>
        </Container>
      ) : (
        <p className="ml-3">No hay datos actualmente</p>
      );
    return <React.Fragment>{VistaDatosSTJ}</React.Fragment>;
  }
}
